import { supportedLanguages } from "$lib/translations/translations";

export function match(param) {
    return supportedLanguages.filter(lang => lang !== 'pt').includes(param);
}